import React, {FC} from 'react';
import styled from 'styled-components';

import {useAppSelector} from '../../../../../helpers/appReduxHelpers';
import {parseApplicationUidFromType} from '../../../../../helpers/models/topicHelpers';
import {getFlatApplications} from '../../../../../store/data/applications/applicationsSelectors';
import {getIntegrationsByType} from '../../../../../store/data/dataSelectors';
import {IntegrationTopicIcon} from '../../../../common/integrationTopicIcon';

/*
 * Props.
 */

interface SearchSuggestionsDropdownDynamicObjectItemIconProps {
  type: string;
}

/*
 * Style.
 */

const StyledApplicationImageWrapperDiv = styled.div`
  display: flex;
`;

const StyledApplicationImg = styled.img`
  height: 16px;
  width: 16px;
`;

const StyledIntegrationTopicIconWrapperDiv = styled.div`
  display: flex;
  height: 20px;
  width: 20px;
  margin: 0px -3px;
`;

/*
 * Component.
 */

export const SearchSuggestionsDropdownDynamicObjectItemIcon: FC<
  SearchSuggestionsDropdownDynamicObjectItemIconProps
> = (props) => {
  const {type} = props;

  const applications = useAppSelector(getFlatApplications);
  const integrationsByType = useAppSelector(getIntegrationsByType);

  const applicationUid = parseApplicationUidFromType(type);

  if (applicationUid) {
    const application = applications.find((app) => app.uid === applicationUid);

    if (application && application.iconUrl) {
      return (
        <StyledApplicationImageWrapperDiv>
          <StyledApplicationImg src={application.iconUrl} />
        </StyledApplicationImageWrapperDiv>
      );
    }

    return null;
  }

  const integration = integrationsByType[type];

  if (integration && integration.topicType && integration.topicType.image) {
    return (
      <StyledIntegrationTopicIconWrapperDiv>
        <IntegrationTopicIcon integrationTopicIconUrl={integration.topicType.image} />
      </StyledIntegrationTopicIconWrapperDiv>
    );
  }

  return null;
};
